import {
  Box,
  Button,
  Heading,
  HStack,
  Icon,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FaCircleCheck } from "react-icons/fa6";
import { ImArrowRight } from "react-icons/im";

import { DialogBody, DialogContent } from "@/components/ui/dialog";
import { formatNumberToLocale } from "@/utils";

type TicketsConvertedModalContentProps = {
  ticketsConverted: number;
  ppGained: number;
  onClose: () => void;
};

export const TicketsConvertedModalContent = ({
  ticketsConverted,
  ppGained,
  onClose,
}: TicketsConvertedModalContentProps) => {
  return (
    <DialogContent>
      <DialogBody p={7}>
        <VStack gap={6}>
          {/* Header with checkmark and title */}
          <VStack gap={0}>
            <Icon as={FaCircleCheck} color="#00827B" w="40px" h="40px" mb={4} />
            <Heading
              fontFamily="heading"
              fontSize="24px"
              fontWeight="700"
              lineHeight="32px"
              letterSpacing="-0.47px"
              textAlign="center"
            >
              Tickets converted successfully!
            </Heading>
            <Text>
              {ppGained} Plume Points will be added tonight at midnight UTC
            </Text>
          </VStack>

          {/* Conversion display */}
          <HStack
            bg="bg.muted"
            px={6}
            py={8}
            rounded="16px"
            w="full"
            justifyContent="center"
            gap={6}
          >
            {/* Tickets */}
            <HStack gap={2}>
              <Box
                bg="#896EFD"
                rounded="full"
                w="24px"
                h="24px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Image
                  src="/assets/daily-spin/ticket-icon.svg"
                  alt=""
                  w="15px"
                  h="15px"
                />
              </Box>
              <Heading
                fontFamily="heading"
                fontSize="24px"
                fontWeight="700"
                lineHeight="32px"
                letterSpacing="-0.47px"
              >
                {formatNumberToLocale(ticketsConverted)}
              </Heading>
            </HStack>

            {/* Arrow */}
            <Icon as={ImArrowRight} color="#888888" w="32px" h="32px" />

            {/* PP */}
            <HStack gap={2}>
              <Image src="/assets/pp-circle.svg" alt="" w="24px" h="24px" />
              <Heading
                fontFamily="heading"
                fontSize="24px"
                fontWeight="700"
                lineHeight="32px"
                letterSpacing="-0.47px"
              >
                {formatNumberToLocale(ppGained)}
              </Heading>
            </HStack>
          </HStack>

          {/* Close button */}
          <Button
            variant="outline"
            w="full"
            rounded="full"
            h="44px"
            onClick={onClose}
          >
            Close
          </Button>
        </VStack>
      </DialogBody>
    </DialogContent>
  );
};
